import React from 'react';
import PropTypes from 'prop-types';

import { faCirclePlus } from '@fortawesome/pro-regular-svg-icons';

import { connect } from 'react-redux';
import { addStep } from './store/workflow/actions';

import { Button } from 'components/ui/button';

export const Header = ({ addStep, workflow }) => {
  if (!workflow || workflow.steps.length === 0) {
    return null;
  }
  return (
    <div className="d-flex justify-content-between align-items-center gap-2">
      <h5>Voucher Approval Workflow</h5>
      <Button icon={faCirclePlus} label="Add Step" size="sm" variant="ghost" onClick={addStep} />
    </div>
  );
};

Header.propTypes = {
  addStep: PropTypes.func.isRequired,
  workflow: PropTypes.object.isRequired,
};

const mapDispatchToProps = {
  addStep,
};

const mapStateToProps = state => ({
  workflow: state.workflow
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);

